<template>
<div id="vue_place_order">
    <!-- Modal -->

    <div class="modal fade" id="extraItemModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog animate-bottom" role="document" style="margin: 0px; width: 100%;max-width: none;">
    <div class="modal-content">
      <div class="modal-body" style="background: #f1f1f1;">
		<div class="row">
			<div class="col-12" style="">
                <button type="button" @click="closeModel()" data-dismiss="modal" aria-label="Close" class="close"><span aria-hidden="true">×</span></button>
				<span style="color:#787878; font-size:12px;">{{this.extra_item_name}}</span>
				<p class="title" style="font-weight:500; font-size: 22px !important;">{{ $t("message.customise_test", {}, { locale: lang }) }}</p>
			</div>
		</div>	
		<hr>
		<div class="row" style="overflow-y: scroll;
    max-height:169px; margin-bottom: 37px;">
			
			<div class="col-12">	
				<p class="title mb-1" style="font-weight:500;">{{ $t("message.add_ons", {}, { locale: lang }) }}</p>
			</div>
			<div class="col-12 mb-1" v-for="(ex_item) in extra_items" :key="ex_item.id">	
				<div class="addon">
				<p style="margin-right:50px; line-height:1.2; margin-bottom: 0px; font-size: 22px;">
				{{ ex_item.extra_item }}
				</p>
				<p style="position:absolute;top:10px;right:20px; font-family:Okra,Helvetica,sans-serif !important;">
				<!-- <i class="fas fa-rupee-sign" style="color: #4d4d4e; font-size: 12px;"></i>{{ ex_item.price }} <input style="height: 14px !important; margin-bottom: 6px;" @change="checkAddon($event, ex_item.id, index)" type="checkbox" > -->
                {{this.currency}} {{parseFloat(ex_item.price).toFixed(2) }} <input :value="ex_item.id" style="height: 14px !important; margin-bottom: 2px;" @change="checkAddon($event, ex_item.price, index)" v-model="checkedProducts" type="checkbox" >
				</p>
				</div>
			</div>
		</div>
		<!-- <section class="bottom-cart"> -->
        <!-- <div class="container"> -->
            <div class="row" style="background: white;
                position: fixed;
                bottom: 0;
                width: 100%;
                z-index: 111;
                padding: 5px;">
				<div class="col-5">
                   
                <p class="price" style="font-family:Okra,Helvetica,sans-serif !important;">{{this.currency}} {{parseFloat(this.extra_item_price).toFixed(2) }}</p>
                </div>
				<div class="col-7">			
					<button type="button" @click="ItemWithExtra()" class="btn btn-danger btn-block mt-1">{{ $t("message.add_to_cart", {}, { locale: lang }) }}</button>
				</div>
			</div>
		<!-- </div>	 -->
    <!-- </section> -->
		
	</div>
    </div>
  </div>
</div>

    <div style="z-index:99999;" class="modal fade" id="foodview" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog animate-bottom" role="document" style="margin: 0px; width: 100%;max-width: none;" v-on:click="bottomclose();">
        <div class="modal-content">
        <div class="modal-body">
            <div class="row">
                <div class="col-12">
                    <button type="button" data-dismiss="modal" aria-label="Close" class="close"><span aria-hidden="true">×</span></button>
                </div>
                <div class="col-12">
                <img class="mb-3 item" v-if="modal_item !=null" style="width:100%; height:190px; object-fit: contain;" :src="this.vue_app_base_url+modal_item.item_logo">
                </div>
                <div class="col-12">				
                    <p class="title" style="font-size:26px !important;" v-if="modal_item !=null ">{{modal_item.name}}</p>
                    <span style="overflow-y:scroll; max-height:100px;" class="include" v-if="modal_item !=null ">{{modal_item.long_desc}}</span>
                    <p class="price" style="font-family: Okra,Helvetica,sans-serif !important; font-size:20px !important;"  v-if="modal_item !=null ">{{currency}} {{modal_item.price}}</p>
                                        
                </div>
                
            </div>
        </div>
        </div>
    </div>
    </div>
    <!--::header part start::-->
    <header class="main_menu">
        <!-- Modal -->
        <div  class="modal fade" id="main-modal" tabindex="main-modal" role="dialog" aria-labelledby="exampleModalCenterTitle">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content" style="border-radius: 15px;margin: 0 15px; padding: 16px 0;">
            <div class="modal-body">
            <i class="fa fa-times" aria-hidden="true" style="position:absolute; right:15px; top:10px;font-size: 20px;" data-dismiss="modal"></i>
            
            <p style="font-size:21px;margin-bottom:10px;" class="text-center">{{ $t("message.selectcategory", {}, { locale: lang }) }}</p>
                <ul id="style-2" style="overflow-y: scroll; height: 134px; padding-left: 0; margin-bottom:30px;">            
                        <li v-for="(category,index) in categories" :key="category.id"  v-on:click="getSubcategories1(category.id,category.name,index)"  style="border-bottom: 1px solid #e9e9e9; font-size: 18px; color: #000; font-family: Okra,Helvetica,sans-serif !important;"><a style="color: #585858; text-decoration: none;
        display: block;
        width: 100%;
        height: 100%;" href="#"> <i class="fas fa-angle-right" style="float:right;margin-top: 7px;"></i>{{category.name}}</a></li>
        </ul>
            </div>
            
            </div>
        </div>
        </div>
        
        <div class="container">
            
            <div class="row align-items-center">
                <div class="col-lg-12">
                <nav class="navbar navbar-expand-lg navbar-light">
                        <a class="navbar-brand" :href="'#/'+restaurant_id+'/'+table_id"> <i style="background: #f7f7f7; padding: 4px 5px; border-radius: 5px; box-shadow: 2px 2px #d1cfcf; font-size: 12px;" class="fas fa-chevron-left"></i> </a>
						<a class="navbar-brand mr-auto" :href="'#/menu/'+restaurant_id+'/'+table_id"> <img :src="this.logo" style="object-fit: contain; max-height: 42px; border-radius: 33%;" @error="ResimageLoadError" alt="logo"> </a>
                        
						<ul style="margin-bottom: 0;padding-left:0;">
                        <li>
                        <i class="fas fa-globe  dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="font-size: 16px; margin-right: 10px; padding-top: 5px;"></i>
                            <div class="dropdown-menu bgs" style="box-shadow: 2px 2px 7px #a7a7a7; left:auto; right:0;">
                            <a @click="handleChange('en-us')" :style="{color: eng_lang ? 'red' : '#000000'}" class="dropdown-item" data-value="en"> <flag iso="us" /> English</a>
                            <!-- <a @click="handleChange('th')" :style="{color: thai_lang ? 'red' : '#000000'}" class="dropdown-item" data-value="th"> <flag iso="th" /> ไทย </a>
                            <a @click="handleChange('ja')" :style="{color: jap_lang ? 'red' : '#000000'}" class="dropdown-item" data-value="th"> <flag iso="jp" /> 日本 </a>
                            <a @click="handleChange('ko')" :style="{color: ko_lang ? 'red' : '#000000'}" class="dropdown-item" data-value="th"> <flag iso="kp" /> 韓国語 </a>
                            <a @click="handleChange('it')" :style="{color: it_lang ? 'red' : '#000000'}" class="dropdown-item" data-value="th"> <flag iso="it" /> italiano</a>
                            <a @click="handleChange('zh-hans')" :style="{color: ch_lang ? 'red' : '#000000'}" class="dropdown-item" data-value="th"> <flag iso="cn" /> 简体中文</a> -->
                            <!-- <template v-if="this.lang1">
                            <a @click="handleChange('ro')" :style="{color: ro_lang ? 'red' : '#000000'}" class="dropdown-item" data-value="th"> <flag iso="ro" /> România</a>
                            </template> -->
                            <!-- <a @click="handleChange('ru')" :style="{color: ru_lang ? 'red' : '#000000'}" class="dropdown-item" data-value="th"> <flag iso="ru" /> русский</a> -->
                            <!-- <template v-if="this.lang2">
                            <a @click="handleChange('uk')" :style="{ color: uk_lang ? 'red' : '#000000' }" class="dropdown-item" data-value="th"><flag iso="ua" /> Україна</a>
                            </template> -->
                            <template v-for="lang in this.lang_list" :key="lang.id">
                                <a
                                @click="handleChange(lang.language)"
                                :style="{ color: lang_select == lang.language ? 'red' : '#000000' }"
                                class="dropdown-item"
                                data-value="th"
                            >
                            <template v-if="lang.language == 'uk'"> <flag iso="ua" /> {{lang.country}} </template> <template v-else> <flag :iso="lang.language" /> {{lang.country}} </template>
                            </a>
                            </template>
                            </div> 
                        </li>
                        </ul>
						<a style="margin-right: 1px;" class="navbar-brand" v-on:click="refreshpage()"><i class="fas fa-redo-alt" style="font-size: 16px;"></i></a>
						<ul style="margin-bottom: 0;padding-left:0;">
						<li>
							<!-- <i style="margin-left: 13px;" class="fas fa-ellipsis-v dropdown-toggle-split"
                          data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></i> -->
                          <a :href="'#/order/history/'+session_id" class="dropdown-item" style="padding: 0.25rem 0rem 0.25rem 1rem;background-color: #fff;"><i class="fas fa-shopping-cart"></i></a>
							<!-- <div class="dropdown-menu bgs" style="box-shadow: 2px 2px 7px #a7a7a7; left:auto; right:0;">
								<a class="dropdown-item" v-on:click="addHelp();"> <i class="fas fa-concierge-bell"> {{ $t("message.help", {}, { locale: lang }) }} </i></a>
								<a :href="'#/restaurant/order/history/'+session_id" class="dropdown-item"><i class="fas fa-clipboard-list">  {{ $t("message.orderstatus", {}, { locale: lang }) }}</i></a>
							</div>	 -->
						</li>		
						</ul>

                        
                </nav>
                </div>
                
            </div>
        </div>
    </header>

    <div v-if="isLoading" style="text-align:center">
         <img src="" style="margin-top:120px;" @error="Loader" alt="logo">
    </div>


    <section class="exclusive_item_part blog_item_section" style="padding-top: 0px;">

        <div class="container" v-show="isLoaded" @load="loaded">
			
            <!-- <div style="margin-top: 8px;" id="carouselExampleControls" class="carousel slide" data-ride="carousel" >
				<div class="carousel-inner">
                <template v-for="(offer,index) in offers" :key="offer.id">
                <div class="carousel-item active"  v-if="index==0">
                    <img class="d-block w-100 brad" :src="this.vue_app_base_url+offer.offer_image" @error="offerimageLoadError">
                </div>
                <div class="carousel-item" v-else>
                    <img class="d-block w-100 brad" :src="this.vue_app_base_url+offer.offer_image" @error="offerimageLoadError">
                </div>
                </template>
                
				</div>
				<a class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
					<span class="carousel-control-prev-icon" aria-hidden="true"></span>
					<span class="sr-only">Previous</span>
				</a>
				<a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
					<span class="carousel-control-next-icon" aria-hidden="true"></span>
					<span class="sr-only">Next</span>
				</a>
			</div> -->
            <div class="row" style="-webkit-box-align: center;
                        align-items: center;
                        background: rgb(255, 255, 255);
                        height: 2.2rem;
                        position: sticky;
                        top: 38px;
                        z-index: 111;">
                <div class="col">
                    <div class="row ici">
                        <div class="col-12">
                            <div class="" >  
                                <p class="" v-on:click='selectPopup();' style="text-align:center !important; font-size:19px; color:black; margin-bottom:0px;"><span class="selectedmenu"> {{active_category}} </span><i></i> <i style="font-size:14px;" class="fas fa-chevron-down"></i></p>    
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" style="border-collapse: collapse;
    overflow: hidden;
    padding: 4px 0px; margin-top:10px; margin-bottom:1px; margin-top:5px;position: sticky;
    top: 70px;
    z-index: 111;
    background: #fff;">
            <div class="col-8">
                <!-- <p class="title" style="    font-size: 16px !important;">{{ $t("message.ordertogether", {}, { locale: lang }) }}</p> -->
                <!-- <span style="font-size: 14px;color: #909090;display: block;line-height: 1.3;margin-bottom: 8px;">{{ $t("message.sharepin", {}, { locale: lang }) }}</span> -->
                <span style="border: 1px solid #f3f3f3;border-radius: 5px;padding: 3px;color: #32c727;font-weight: 600;margin-bottom: 8px;">{{ $t("message.tablepin", {}, { locale: lang }) }} : {{table_pin}}</span>
            </div>
            <div class="col-2">
            </div>    
            <div class="col-2">
                <!-- <img style="width: 100px;" src="@/assets/website/img/order_together.jpg"> -->
                <a v-on:click="addHelp();" class="hov"> <i class="fas fa-concierge-bell" style="font-size:20px;"></i></a>
            </div>
            </div>
     
            <div class="example-one st" style="-webkit-box-align: center;
                align-items: center;
                background: rgb(255, 255, 255);
                position: sticky;
                top: 100px;
                z-index: 111;margin-bottom: 8px; margin-right: -15px;
    margin-left: -15px;
    padding: 0 13px;">
                        <header class="example-one-header scroll vcvc" style="display: flex;
                        flex-wrap: nowrap;">
                    <nav class="flex" style="margin-bottom:5px;">
                        <a style="font-size: 17px !important; font-family: Okra,Helvetica,sans-serif !important;" v-for="(subcategory,index) in subcategories" class="nav-item "  :class="{scrolla:subcategory.id == selected}" @click="selected = subcategory.id" v-on:click="getItem(subcategory.id,index)" :key="subcategory.id">{{subcategory.name}}</a>
                    </nav>
                </header>
            </div>

            
            <div class="row kia" v-for="(item,index) in items" :key="item.id" style="margin-bottom:10px">
                <div class="col-8 kiap">
                    <div v-if="item.item_logo">
                        <p class="title" style="font-size: 17px !important;font-weight: 400;">{{item.name}} <i class="fa fa-info-circle" aria-hidden="true" v-on:click="bottomModal(item);"> </i></p>
                    </div>
                    <div v-else>
                        <p class="title" style="font-size: 17px !important;font-weight: 400;">{{item.name}}</p>
                    </div>
                    
                    <span class="include"  v-if="item.show==0" style="white-space:pre-wrap; font-size: 14px !important; line-height: 1.3;">{{item.short_desc}}<a v-if="item.readmore==1" v-on:click=showText(1,index) style="color:red">{{ $t("message.readmore", {}, { locale: lang }) }}</a></span>
                    <span class="include"  v-if="item.show==1" style="white-space:pre-wrap; font-size: 14px !important; line-height: 1.3;">{{item.long_desc}}<a  v-on:click=showText(0,index) style="color:red">{{ $t("message.readless", {}, { locale: lang }) }} </a></span>
                    <p class="price" style="font-family: Okra,Helvetica,sans-serif !important;" > {{currency}} {{parseFloat(item.price).toFixed(2) }}</p> 
                    
                </div>

                <div class="col-4 text-center pres">
                    <!-- <div style="width:100px; float:right;">   
                        <img class="item" style="height: 100px; width: 100px;" v-on:click="bottomModal(item);" :src="this.vue_app_base_url+item.item_logo" @error="imageLoadError">
                    </div>                                                                                                   -->
                    
                    <!-- ADD Button -->
                    <template v-if="this.lang === 'en-us'">
                    <div v-if="item.count==0 && item.out_of_stock==0 && this.direct_order=='false'" v-show=true>
                        <input style="font-size: 18px !important;" type="button" v-on:click="manageItem(item.id,1,$event,item.price,item.count, index);" class="adbtn" :value="$t('message.add', {}, { locale: lang })" />
					</div>
                    </template>

                    <template v-else>
                    <div v-if="item.count==0 && item.out_of_stock==0 && this.direct_order=='false'" v-show=true>
                        <input style="font-size: 14px !important;" type="button" v-on:click="manageItem(item.id,1,$event,item.price,item.count, index);" class="adbtnro" :value="$t('message.add', {}, { locale: lang })" />
					</div>
                    </template>
                    <!-- ADD Button -->

                    
                    <!-- Hide ADD Button -->
                    <template v-if="this.lang === 'en-us'">
                    <div v-if="item.count==0 && item.out_of_stock==0 && this.direct_order=='true'" v-show=false>
                        <input style="font-size: 18px !important;" type="button" v-on:click="manageItem(item.id,1,$event,item.price,item.count, index);" class="adbtn" :value="$t('message.add', {}, { locale: lang })" />
					</div>
                    </template>

                    <template v-else>
                    <div v-if="item.count==0 && item.out_of_stock==0 && this.direct_order=='true'" v-show=false>
                        <input style="font-size: 14px !important;" type="button" v-on:click="manageItem(item.id,1,$event,item.price,item.count,index);" class="adbtnro" :value="$t('message.add', {}, { locale: lang })" />
					</div>
                    </template>
                    <!-- Hide ADD Button -->

                    <!-- <div style="width:114px; float:right;"> -->
                    <div v-if="item.count > 0 && item.out_of_stock==0" class="number btn rrr">
                        <span class="minus fas fa-minus lcount"  v-on:click="manageItem(item.id,0,$event,item.price,item.count, index);"></span>
                        <input type="button" class="icount" v-model="item.count" />
                        <span class="plus fas fa-plus rcount" v-on:click="manageItem(item.id,1,$event,item.price, item.count, index);"></span>
                    </div>
                    <!-- </div> -->
                    <div v-if="item.out_of_stock==1">
                        <div style="height:100px; width:100px;" class="ribbon"><span>{{ $t("message.out_of_stock", {}, { locale: lang }) }}</span></div>
					</div>

                </div>	
            </div>
            
        </div>
    </section>
    <section style="visibility:hidden;">
        <div style="padding:30px 0 !important;"><p>&nbsp;</p></div>
    </section>
    <section v-if="this.direct_order =='true'" class="bottom-cart" v-show=false>
        <div class="container">
            <div class="row">
			<div class="col-6">
                <span style="font-size:12px; color:f3f3f3;">{{cart_item}} {{ $t("message.item", {}, { locale: lang }) }}</span>
				<p class="price" style="margin-bottom: 0px;"><i aria-hidden="true"></i> {{currency}} {{parseFloat(total_amount).toFixed(2) }} <span style="font-size:10px;">{{ $t("message.plustaxes", {}, { locale: lang }) }}</span></p>
                </div>
			<div class="col-6" style="z-index: 9999;"> 			
				<button type="button" class="btn btn-danger btn-block mt-1" @click="goToOrderDetail(this.cart_item);">{{ $t("message.proceed", {}, { locale: lang }) }}</button>
			</div>
			</div>
            
		</div>	
    </section>
    <section v-if="this.direct_order =='false'" class="bottom-cart" v-show=true>
        <div class="container">
            <div class="row">
			<div class="col-6">
                <span style="font-size:12px; color:f3f3f3;">{{cart_item}} {{ $t("message.item", {}, { locale: lang }) }}</span>
				<p class="price" style="margin-bottom: 0px; font-family: Okra,Helvetica,sans-serif !important;"><i aria-hidden="true"></i> {{currency}} {{parseFloat(total_amount).toFixed(2) }} <span style="font-size:10px;">{{ $t("message.plustaxes", {}, { locale: lang }) }}</span></p>
                </div>
			<div class="col-6" style="z-index: 9999;"> 			
				<button type="button" class="btn btn-danger btn-block mt-1" @click="goToOrderDetail(this.cart_item);">{{ $t("message.proceed", {}, { locale: lang }) }} </button>
			</div>
			</div>
            
		</div>	
    </section>
</div>

</template>

<script>
import "@meforma/vue-toaster";

export default {
  name: 'Landing',
  data: function (){
    return {
        lang: "",
        cart_item:0,
        total_amount:0,
        categories:[],
        subcategories:[],
        items:[],
        active_category:null,
        session_id:null,
        restaurant_id:null,
        table_id:null,
        currency:null,
        logo:null,
        selected:null,
        eng_lang: false,
        thai_lang: false,
        jap_lang: false,
        ko_lang: false,
        it_lang: false,
        ch_lang: false, 
        ro_lang: false,
        ru_lang: false,
        uk_lang: false,
        offers: [],
        modal_item:null,
        table_pin:null,
        vue_app_base_url: null,
        direct_order:'',
        isLoaded: false,
        isLoading: false,
        extra_items: [],
        extra_item_name: '',
        extra_item_price: '',
        checkedProducts: [],
        extra_item_id: '',
        lang_list: [],
        lang_select: '',
        url11: ''
    }
  },
  methods: {
      bottomclose: function(){
        this.jQuery("#foodview").modal('hide');
      },
      loaded: function() {
        this.isLoaded = true;
        this.isLoading = false;
    },
      bottomModal: function(item){
          this.modal_item = item;
          this.jQuery("#foodview").modal('show');
      },
      closeModel: function(){
        location.reload();
      },
      ItemWithExtra: function(){

            // alert(this.checkedProducts);   
            // alert(this.extra_item_id);   
            // alert(this.session_id);     
            // alert(this.manage_type); 
            // alert(this.lang);

            var data = {
                "order_json": {"session_uuid": this.session_id, "item_id": this.extra_item_id, "manage_type":this.manage_type, "language_code":this.lang, "extra_item":this.checkedProducts}
            }
            // const newData =  JSON.stringify(data)
            var config = {
                method: 'post',
                    url: process.env.VUE_APP_BASE_URI+'/api/userapi/order/manage/add_on/',
                    data: data,
                    headers: {
                }
            };
            this.axios(config)
            .then(response => {
            if(response.status){

                this.jQuery("#extraItemModal").modal('hide');
                console.log(response.data.data);
                this.items = response.data.data.item;
                this.total_amount = response.data.data.total_cart_amount;
                this.cart_item = response.data.data.total_item_count;
                this.checkedProducts = [];
                // location.reload();
            }

            });

            
        },
      checkAddon: function(event,price,index){
        //   alert(event.target.checked);
        //   alert(id);

          if(event.target.checked){
              this.extra_item_price = this.extra_item_price + price;
          }
          else{
              this.extra_item_price = this.extra_item_price - price;
          }
          console.log(event);
          console.log(index);
      },
      manageItem: function(item_id,manage_type,event,price, item_count, index){
            // console.log(price)
            // alert(item_count);
            if(manage_type== 1 && item_count >=50){
                this.$toast.error(this.$t("message.item_count", {}, { locale: this.lang }),{
            position:"bottom",
            duration:2000
            })
            return false;
            }
            if(item_count < 0){
                this.$toast.error(this.$t("message.cannotaddnegative", {}, { locale: this.lang }),{
            position:"bottom",
            duration:2000
            })
            return false;
            }

            this.extra_items = this.items[index].extra_item_item;
            if(this.extra_items.length > 0 && manage_type === 1){

                this.extra_item_name = this.items[index].name;
                this.extra_item_price = this.items[index].price;
                this.extra_item_id = this.items[index].id;
                this.manage_type = manage_type;
                // alert(this.manage_type)
                this.jQuery("#extraItemModal").modal('show');
            }

            var $ = this.jQuery;
            var $input = $(event.target.parentElement).find('input');
            if($input.val() == 'ADD' && manage_type == 0){
                return false
            }

            if(this.extra_items.length > 0 && manage_type === 0){

            this.session_uuid = this.$store.state.session_id;
            this.$router.push('/order_detail/'+this.session_uuid+'/');
            }

            if(this.extra_items.length === 0){
                var data = {
                "order_json": {"session_uuid": this.session_id, "item_id": item_id, "manage_type":manage_type, "language_code":this.lang, "extra_item":[]}
            }
            // const newData =  JSON.stringify(data)
            

            var config = {
                method: 'post',
                    url: process.env.VUE_APP_BASE_URI+'/api/userapi/order/manage/add_on/',
                    data: data,
                    headers: {
                }
            };
            this.axios(config)
            .then(response => {
                // alert(response.status.code)
                
            if(response.status){

                console.log("*************")
                // console.log(response.status)
                //console.log(response.data.data.sessionitem_tablesession);
                this.items = response.data.data.item;
                console.log(response.data.data.item);
                this.total_amount = response.data.data.total_cart_amount;
                this.cart_item = response.data.data.total_item_count;
            }
            });
            
            }
      },
      getItem: function(sub_category, index){

        sub_category = sub_category || null;
        index = index || null;

        console.log(this.$store.state.session_id);
        console.log(index);
        this.isLoaded =  false;
        this.isLoading = true;

        if(sub_category == null){
           this.url11 = process.env.VUE_APP_BASE_URI+'/api/userapi/restaurant/all/menu/'+this.session_id+'/'+this.lang
        }
        else{
            this.url11 = process.env.VUE_APP_BASE_URI+'/api/userapi/restaurant/all/menu/'+this.session_id+'/'+this.lang+'/?subcategory_id='+sub_category
        }


        var config = {
        method: 'get',
            // url: process.env.VUE_APP_BASE_URI+'/api/userapi/restaurant/menu/'+this.$store.state.session_id+'/'+sub_category+'/'+this.lang,
            
            url: this.url11,
            headers: {
            }
        };
        this.axios(config)
        .then(response => {
        if(response.data.code == 200){

            console.log("in menu/:", response.data)

            this.isLoaded =  true;
            this.isLoading = false;
            var data = response.data.data.item;
            this.cart_item = response.data.data.total_item_count;
            this.total_amount = response.data.data.total_cart_amount
            this.items = data;
            console.log("this items:", this.items);
            this.modal_item = this.items[0];
        }
        else{
            // console.log("in menu/:", response.data)
        var session_id = localStorage.removeItem('session_id');
        this.session_id = session_id;
        
        localStorage.removeItem('pin')
        localStorage.removeItem('order_id')
        localStorage.removeItem('phone')
        localStorage.removeItem('name')
        localStorage.removeItem('grand_total')
        localStorage.removeItem('personal_detail')
        localStorage.removeItem('instruction')

        window.location.href= '#/'+localStorage.getItem('restaurant_id')+'/'+localStorage.getItem('table_id');

        // this.$router.push('#/'+this.restaurant_id+'/'+this.table_id);
      }
        });

      },
      getSubcategories: function(category_id,category_name,index){
    
        this.active_category = category_name;
        this.active_category = this.$t("message.selectcategory", {}, { locale: this.lang })
        
        console.log(index);
        var config = {
        method: 'get',
            url: process.env.VUE_APP_BASE_URI+'/api/userapi/restaurant/subcategory/'+category_id+'/'+this.lang,
            headers: {
            }
        };
        this.axios(config)
        .then(response => {
        if(response.status==200){

            var data = response.data.data.subcategory;
            this.subcategories = data;
            this.getItem();
            // this.selected = this.subcategories[0].id;

        }
        });

        this.jQuery('#main-modal').modal('hide');
      },

      getSubcategories1: function(category_id,category_name,index){
          
          event.preventDefault();
        this.active_category = category_name;
        console.log(index);
        var config = {
        method: 'get',
            url: process.env.VUE_APP_BASE_URI+'/api/userapi/restaurant/subcategory/'+category_id+'/'+this.lang,
            headers: {
            }
        };
        this.axios(config)
        .then(response => {
        if(response.status==200){
            var data = response.data.data.subcategory;
            this.subcategories = data;
            this.getItem(data[0].id,-1);
            this.selected = this.subcategories[0].id;

        }
        });

        this.jQuery('#main-modal').modal('hide');
      },
      goToOrderDetail: function(cart_item){

          if(!navigator.onLine){
        this.$toast.error(this.$t("message.no_internet", {}, { locale: this.lang }),{
            position:"bottom",
            duration:2000
            })

            return false;
      }
      else{

          if (cart_item<=0){
            this.$toast.error(this.$t("message.cartempty", {}, { locale: this.lang }),{
            position:"bottom",
            duration:2000
            })
          }
          else {
          this.session_uuid = this.$store.state.session_id;
          this.$router.push('/order_detail/'+this.session_uuid+'/');
          }
          }
      },

      selectPopup: function(){
        
            this.jQuery('#main-modal').modal('show');
      },
        showText: function(toggle, index){
            this.items[index]['show'] = toggle;
        },
        // imageLoadError: function(event){
        //     event.target.src = require('@/assets/img/default_food.jpg');
        // },
        offerimageLoadError: function(event){
            event.target.src = require('@/assets/img/default_offer.jpg');
        },
        ResimageLoadError: function(event){
            event.target.src = require("@/assets/website/img/logo.png");
        },
        Loader: function(event){
            event.target.src = require("@/assets/website/img/loading.gif");
        },
        addHelp: function(){

            if(!navigator.onLine){
        this.$toast.error(this.$t("message.no_internet", {}, { locale: this.lang }),{
            position:"bottom",
            duration:2000
            })

            return false;
      }
      else{
            this.$toast.success(this.$t("message.helpwaiter", {}, { locale: this.lang }),{
            position:"bottom",
            duration:2000
            })
            var config = {
            method: 'get',
                url: process.env.VUE_APP_BASE_URI+'/api//userapi/waiter/help/'+this.session_id+'/',
                headers: {
                }
            };
            this.axios(config)
            .then(response => {
            if(response.status){
                console.log(response.status);
            }
            });
            }
        },

        refreshpage: function(){
            if(navigator.onLine){
            window.location.reload();
            }
            else{
                this.$toast.error(this.$t("message.no_internet", {}, { locale: this.lang }),{
            position:"bottom",
            duration:2000
            })
            }
        },

        handleChange: function(a){
            localStorage.setItem('lang', a);
            this.lang = a;


            if (a === 'en-us') {
                this.eng_lang = true;
                // this.thai_lang = false;
                // this.jap_lang = false;
                // this.ko_lang = false;
                // this.it_lang = false;
                // this.ch_lang = false;
                // this.ro_lang = false;
                // this.ru_lang = false;
                // this.uk_lang = false;
                this.lang_select = ''
            }
            else if (a === 'th'){
                // this.thai_lang = true;
                // this.eng_lang = false;
                // this.jap_lang = false;
                // this.ko_lang = false;
                // this.it_lang = false;
                // this.ch_lang = false;
                // this.ro_lang = false;
                // this.ru_lang = false;
                // this.uk_lang = false;
                this.lang_select = a;
                this.eng_lang = false;
            }
            else if (a === 'ko'){
                // this.ko_lang = true;
                // this.thai_lang = false;
                // this.jap_lang = false;
                // this.eng_lang = false;
                // this.it_lang = false;
                // this.ch_lang = false;
                // this.ro_lang = false;
                // this.ru_lang = false;
                // this.uk_lang = false;
                this.lang_select = a;
                this.eng_lang = false;
            }
            else if (a === 'ja'){
                // this.jap_lang = true;
                // this.thai_lang = false;
                // this.eng_lang = false;
                // this.ko_lang = false;
                // this.it_lang = false;
                // this.ch_lang = false;
                // this.ro_lang = false;
                // this.ru_lang = false;
                // this.uk_lang = false;
                this.lang_select = a;
                this.eng_lang = false;
            }
            else if (a === 'it'){
                // this.it_lang = true;
                // this.thai_lang = false;
                // this.jap_lang = false;
                // this.ko_lang = false;
                // this.eng_lang = false;
                // this.ch_lang = false;
                // this.ro_lang = false;
                // this.ru_lang = false;
                // this.uk_lang = false;
                this.lang_select = a;
                this.eng_lang = false;
            }
            else if (a === 'zh-hans'){
                // this.ch_lang = true;
                // this.thai_lang = false;
                // this.jap_lang = false;
                // this.ko_lang = false;
                // this.it_lang = false;
                // this.eng_lang = false;
                // this.ro_lang = false;
                // this.ru_lang = false;
                // this.uk_lang = false;
                this.lang_select = a;
                this.eng_lang = false;
            }
            else if (a === 'ro'){
                // this.ro_lang = true;
                // this.thai_lang = false;
                // this.jap_lang = false;
                // this.ko_lang = false;
                // this.it_lang = false;
                // this.ch_lang = false;
                // this.ru_lang = false;
                // this.uk_lang = false;
                this.lang_select = a;
                this.eng_lang = false;

            }
            else if (a === 'ru'){
                // this.ru_lang = true;
                // this.thai_lang = false;
                // this.jap_lang = false;
                // this.ko_lang = false;
                // this.it_lang = false;
                // this.eng_lang = false;
                // this.ch_lang = false;
                // this.ro_lang = false;
                // this.uk_lang = false;
                this.lang_select = a;
                this.eng_lang = false;
            }
            else if (a === 'uk'){
                // this.uk_lang = true;
                // this.thai_lang = false;
                // this.jap_lang = false;
                // this.ko_lang = false;
                // this.it_lang = false;
                // this.eng_lang = false;
                // this.ch_lang = false;
                // this.ro_lang = false;
                // this.ru_lang = false;
                this.lang_select = a;
                this.eng_lang = false;
            }

            var config = {
            method: 'get',
            url: process.env.VUE_APP_BASE_URI+'/api/userapi/restaurant/category/'+this.$route.params.restaurant_id+'/'+this.$route.params.table_id+'/'+this.lang,
            headers: {
            }
            };
            
            this.axios(config)
            .then(response => {
                console.log("resp:", response);
            if(response.status == 200){
                console.log("hello");
                var data = response.data.data.category;
                this.getSubcategories(data[0].id,data[0].name,-1);
                this.categories = data;

        
      }
    });
        }
  },
  
  mounted: function(){

      if(!localStorage.getItem('session_id')){
          this.$router.push('/pagenotfound/');
      }
    this.jQuery(window).scroll(function () {
    var window_top = this.jQuery(window).scrollTop() + 1;
    if (window_top > 10) {
      this.jQuery('.main_menu').addClass('menu_fixed animated');
    } else {
      this.jQuery('.main_menu').removeClass('menu_fixed animated');
    }
  });

    if (localStorage.getItem('menureload') == '1'){
        localStorage.setItem('menureload',0);
        location.reload();
    }
    
    this.vue_app_base_url= process.env.VUE_APP_BASE_URI;
    var session_id = localStorage.getItem('session_id');
    var restaurant_id = localStorage.getItem('restaurant_id');
    var table_id = localStorage.getItem('table_id');
    var currency = localStorage.getItem('currency');
    var lang = localStorage.getItem('lang');
    this.logo = localStorage.getItem('logo');
    var direct_order = localStorage.getItem('direct_order');
    this.restaurant_id = restaurant_id;
    this.table_id = table_id;
    this.session_id = session_id;
    this.currency =  currency;
    this.lang = lang;
    this.direct_order = direct_order;

    // alert(direct_order);
    this.table_pin = localStorage.getItem('pin');

    if (this.lang === 'en-us') {
        this.eng_lang = true;
        // this.thai_lang = false;
        // this.jap_lang = false;
        // this.ko_lang = false;
        // this.it_lang = false;
        // this.ch_lang = false;
        // this.ro_lang = false;
        // this.ru_lang = false;
        // this.uk_lang = false;
        this.lang_select = '';
    }
    else if (this.lang  === 'th'){
        // this.thai_lang = true;
        // this.eng_lang = false;
        // this.jap_lang = false;
        // this.ko_lang = false;
        // this.it_lang = false;
        // this.ch_lang = false;
        // this.ro_lang = false;
        // this.ru_lang = false;
        // this.uk_lang = false;
        this.lang_select = 'th';
        this.eng_lang = false;
    }
    else if (this.lang  === 'ko'){
        // this.ko_lang = true;
        // this.thai_lang = false;
        // this.jap_lang = false;
        // this.eng_lang = false;
        // this.it_lang = false;
        // this.ch_lang = false;
        // this.ro_lang = false;
        // this.ru_lang = false;
        // this.uk_lang = false;
        this.lang_select = 'ko';
        this.eng_lang = false;
    }
    else if (this.lang  === 'ja'){
        // this.jap_lang = true;
        // this.thai_lang = false;
        // this.eng_lang = false;
        // this.ko_lang = false;
        // this.it_lang = false;
        // this.ch_lang = false;
        // this.ro_lang = false;
        // this.ru_lang = false;
        // this.uk_lang = false;
        this.lang_select = 'ja';
        this.eng_lang = false;
    }
    else if (this.lang  === 'it'){
        // this.it_lang = true;
        // this.thai_lang = false;
        // this.jap_lang = false;
        // this.ko_lang = false;
        // this.eng_lang = false;
        // this.ch_lang = false;
        // this.ro_lang = false;
        // this.ru_lang = false;
        // this.uk_lang = false;
        this.lang_select = 'it';
        this.eng_lang = false;
    }
    else if (this.lang  === 'zh-hans'){
        // this.ch_lang = true;
        // this.thai_lang = false;
        // this.jap_lang = false;
        // this.ko_lang = false;
        // this.it_lang = false;
        // this.eng_lang = false;
        // this.ro_lang = false;
        // this.ru_lang = false;
        // this.uk_lang = false;
        this.lang_select = 'zh-hans';
        this.eng_lang = false;
    }
    else if (this.lang === 'ro'){
        // this.ro_lang = true;
        // this.thai_lang = false;
        // this.jap_lang = false;
        // this.ko_lang = false;
        // this.it_lang = false;
        // this.eng_lang = false;
        // this.ch_lang = false;
        // this.ru_lang = false;
        this.lang_select = 'ro';
        this.eng_lang = false;
    }
    else if (this.lang === 'ru'){
        // this.ru_lang = true;
        // this.thai_lang = false;
        // this.jap_lang = false;
        // this.ko_lang = false;
        // this.it_lang = false;
        // this.eng_lang = false;
        // this.ch_lang = false;
        // this.ro_lang = false;
        // this.uk_lang = false;
        this.lang_select = 'ru';
        this.eng_lang = false;
    }
    else if (this.lang === 'uk'){
        // this.uk_lang = true;
        // this.thai_lang = false;
        // this.jap_lang = false;
        // this.ko_lang = false;
        // this.it_lang = false;
        this.eng_lang = false;
        // this.ch_lang = false;
        // this.ro_lang = false;
        // this.ru_lang = false;
        this.lang_select = 'uk';
    }
    
    console.log(this.lang);
    // this.handleChange();

    if (session_id){
        this.$store.state.session_id = session_id;
    }

    
    var config = {
      method: 'get',
      url: process.env.VUE_APP_BASE_URI+'/api/userapi/restaurant/category/'+this.$route.params.restaurant_id+'/'+this.$route.params.table_id+'/'+this.lang,
      headers: {
      }
    };

    this.isLoaded =  false;
    this.isLoading = true;
    
    this.axios(config)
    .then(response => {

      if(response.status){
        var data = response.data.data.category;
        console.log("data:", response.data);
        // alert(response.data.code);

        if(data.length > 0){

        this.getSubcategories(data[0].id,data[0].name,-1);
        this.categories = data;
        this.isLoaded =  true;
        this.isLoading = false;
        }
        else{
            this.isLoaded =  false;
            this.isLoading = false;
            this.$toast.error(this.$t("message.no_menu", {}, { locale: this.lang }),{
            position:"bottom",
            duration:2000
            })
            
        }

        var config5 = {
      method: "get",
      url:process.env.VUE_APP_BASE_URI +
        "/api/userapi/language/list/" +
        this.restaurant_id +
        "/",
      headers: {},
    };
    this.axios(config5).then((response) => {
      if (response.status) {

          this.lang_list = response.data.data;
          
      }
    });
        
      }
      else{
        var session_id = localStorage.removeItem('session_id');
        this.session_id = session_id;
        
        localStorage.removeItem('pin')
        localStorage.removeItem('order_id')
        // localStorage.removeItem('email')
        // localStorage.removeItem('phone')
        // localStorage.removeItem('name')
        localStorage.removeItem('grand_total')
        localStorage.removeItem('personal_detail')
        localStorage.removeItem('instruction')

        window.location.href= '#/'+localStorage.getItem('restaurant_id')+'/'+localStorage.getItem('table_id');
      }
    });

    // var config1 = {
    //   method: 'get',
    //   url: process.env.VUE_APP_BASE_URI+'/api/userapi/restaurant/offer/'+this.$route.params.restaurant_id,
    //   headers: {
    //   }
    // };
    
    // this.axios(config1)
    // .then(response => {
    //   if(response.status){
    //     var data = response.data.data.offer_list;
    //     if(!data.length){
    //         this.offers = '@/assets/img/default_offer.jpg'
    //     }
    //     else{
    //     this.offers = data;
    //     }
        
        
    //   }
    // });
  },
  

}

</script>

<style scoped>
p{
    /* font-family: Okra,Helvetica,sans-serif !important; */
    font-family: Okra,Helvetica,sans-serif !important;
}
a:hover {
  text-decoration: none;
}
.hov{
    color: #000;
}
.hov:hover{
    color: #000 !important;
}
.tag{
height: max-content;
width: max-content;
background: #ff376e;
-webkit-box-align: center;
align-items: center;
-webkit-box-pack: center;
justify-content: center;
border-radius: 5px;
color: rgb(255, 255, 255);
font-size: 0.66rem;
border: none;
padding: 0.2rem 0.2rem;
letter-spacing: 1px;
}
.title{
    line-height: 1.2;
    /* font-weight:bold; */
    font-size:22px;
    color: #262626;
     margin-bottom: 0;
}
.menu_fixed { 
  position: fixed;
  z-index: 9999 !important;
  width: 100%;
  background-color: #fff;
  box-shadow: 0px 10px 15px rgba(0, 0, 0, 0.05);
  top: 0;
}
.include{
    font-size: 14px;
    color: #7c7c7c;;
    display:block;
}
.item{
    border-radius: 5px;
}
.price{
font-weight: bold;
margin-bottom: 0px;
}
.pres{
    padding:0px !important;
}
.rrr{
    font-size: 18px;padding: 0px 5px 0px 5px;
}
.icount{
    padding-left: 0.2px; 
    font-weight: 900;
    line-height: 0.5px;
    appearance: none;
}
.rcount{
    padding-right: 0px;font-size:15px;padding-left: 3px;
}
.lcount{
    padding-left: 0px; font-size:17px;padding-right: 8px;
}
span {cursor:pointer; }
    .number{
        background: #ffeef5 !important;
        text-align: center !important;
        border-radius: 5px !important;
        position: relative !important;
        /* bottom: 11px !important; */
        top: 14px;
        /* left: 18px; */
        border: 2px solid #ff5f8b !important;
    }
    input{
        height:20px !important;
        width:22px !important;
        text-align: center !important;
        font-size: 16px !important;
        background: #ffeef5 !important;
        border: 1px solid #ffeef5 !important;	
        display: inline-block !important;
        vertical-align: middle !important;
    }
    hr {
      margin-top: 0.40rem;
      margin-bottom: 1rem;
      border: 0;
      border-top: 1px solid rgba(223 220 220 / 70);
    }
    .menu-title{
        font-size: 17px;
        line-height: 1;
        padding: 1rem 0px;
        color: #000;
        margin: 0px;
        margin-block-end: 0px;
        position: sticky;
        top: 106px;
        font-weight:bold;
        z-index: 1;
        display: flex;
    }
    .brad{
        border-radius:11px;
    }
    .bottom-cart{
        background: white;
        padding: 5px 0;
        position: fixed;
        bottom: 0;
        width: 100%;
        z-index: 111;
        box-shadow: rgb(125 125 125 / 45%) 0px 2px 8px;
        margin-top: 20px;
    }
    .adbtn{
        border-radius: 5px; background:#fff !important;
        color: #ff5f8b !important;
        font-size: 14px;font-weight: 600; border: 2px solid #ff5f8b !important;
        position: relative !important;
        /* bottom: 8px !important; */
        top: 14px;
        min-width: 83px !important;
        height: 32px !important;
    }
    .adbtnro{
        border-radius: 5px; background:#fff !important;
        color: #ff5f8b !important;
        font-size: 14px;font-weight: 600; border: 2px solid #ff5f8b !important;
        position: relative !important;
        /* bottom: 8px !important; */
        top: 14px;
        min-width: 91px !important;
        height: 32px !important;
    }
.scroll {
display: flex;
flex-wrap: nowrap;
overflow: auto;
-webkit-overflow-scrolling: touch;
-ms-overflow-style: -ms-autohiding-scrollbar; }

.flex {
display: flex;
flex-wrap: nowrap; }

.nav-item {
flex: 0 0 auto; }

.example-three{
display: block;
border: none; }

.example-three .nav-item {
color: #f6f7ee; }

.example-one-header,
.example-two-header {
border-radius: 3px; }

.example-three-header {
border-radius: 3px 3px 0 0; }

.example-three nav {
background: #727c87; 
border-radius: 0 0 3px 3px; 
}
.nav-item {
padding: 3px 7px;
background-color: rgb(255, 255, 255);
box-shadow: rgb(54 54 54 / 6%) 0px 1px 2px;
border-radius: 6px;
border: 1px solid #c0bfbf;
margin: 8px 8px 4px 0px;
display: flex;
-webkit-box-align: center;
align-items: center;
cursor: pointer;
color: #777777;
}
.titlee {
margin: 24px 0 6px;
font-size: 12px;
text-transform: uppercase;
letter-spacing: .2em;
color: #999; }
.st{
display: flex;
position: sticky;
background-color: rgb(255, 255, 255);
z-index: 2;
transition: top 0.5s ease-in-out 0s;
}
.scrolla{
border: 1px solid #dc3545;
color: #dc3545;}
.scrollb{
background: #ff376e;
color: #fff;
}
.scroll::-webkit-scrollbar {
display: none; }	

.iii {
-webkit-box-align: center;
align-items: center;
background: rgb(255, 255, 255);
height: 2.3rem;
position: sticky;
top: 34px;
z-index: 111;
margin-bottom: 13px;
}  
.prat{
    font-size:13px; font-weight:600; color:#1f1a18;
}
@media (min-width: 768px){
.example-one {
max-width: 740px !important;
} 
}


@keyframes example {
from {background-color: #007bff;}
to {background-color: #ff6325;}
}
.ribbon {
  position: absolute;
  right: 0px !important;
  top: -5px;
  z-index: 1;
  overflow: hidden;
  width: 75px; height: 75px;
  text-align: right;
}
.ribbon span {
  font-size: 9px;
  font-weight: bold;
  color: #FFF;
  text-transform: uppercase;
  text-align: center;
  line-height: 16px;
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  width: 104px;
  display: block;
  background: #ff376e;
  background: linear-gradient(#ff376e 0%, #dc3545 100%);
  box-shadow: 0 3px 10px -5px rgba(0, 0, 0, 1);
  position: absolute;
  top: 25px; 
  right: -20px;
}
.ribbon span::before {
  content: "";
  position: absolute; left: 0px; top: 100%;
  z-index: -1;
  border-left: 3px solid #dc3545;
  border-right: 3px solid transparent;
  border-bottom: 3px solid transparent;
  border-top: 3px solid #dc3545;
}
.ribbon span::after {
  content: "";
  position: absolute; right: 0px; top: 100%;
  z-index: -1;
  border-left: 3px solid transparent;
  border-right: 3px solid #dc3545;
  border-bottom: 3px solid transparent;
  border-top: 3px solid #dc3545;
}
.bmw{
    border-bottom: 1px dashed #efefef;
    border-radius: 10px; 
    margin-bottom: 16px;
}
.kia{
    border-radius: 4px;
    box-shadow: rgb(0 0 0 / 13%) 2px 2px 10px;
    margin: 0 -6px;
}
.kiap{
    padding: 11px;
}
.animate-bottom {
 position: fixed;
    animation: animatebottom 0.8s;
    bottom: 0;
}

.vcvc {
overflow-x: scroll;
}

.vcvc::-webkit-scrollbar {
 width: 2px;
 height: 1px;
 background-color: #fff;
 display:block;
}
.addon{
    background: white;
    padding: 8px 10px;
    border-radius: 8px;
    border: 1px solid #e7e7e7;
}
.vcvc::-moz-scrollbar {
width: 2px;
 height: 1px;
 background-color: #fff;
 display:block;
}
.vcvc::-webkit-scrollbar-thumb {
 background: #000;
}
.vcvc::-moz-scrollbar-thumb {
 background: #000;
}
@keyframes animatebottom {
  from {
    bottom: -300px;
    opacity: 0;
  }

  to {
    bottom: 0;
    opacity: 1;
  }
}
#style-2::-webkit-scrollbar-track
{
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    border-radius: 10px;
    background-color: #F5F5F5;
}

#style-2::-webkit-scrollbar
{
    width: 6px;
    background-color: #F5F5F5;
}

#style-2::-webkit-scrollbar-thumb
{
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
    background-color: #D62929;
}
</style>
